var _defs, _ellipse, _text, _ellipse2, _text2, _ellipse3, _text3, _ellipse4, _text4, _ellipse5, _text5, _ellipse6, _text6, _path, _path2, _path3, _path4, _rect, _text7, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphdrawio2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "391px",
    height: "231px",
    viewBox: "-0.5 -0.5 391 231",
    className: "ge-export-svg-dark",
    content: "<mxfile host=\"Electron\" modified=\"2024-02-10T11:37:41.769Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/22.1.16 Chrome/120.0.6099.109 Electron/28.1.0 Safari/537.36\" etag=\"u_B4XkU3fWEpNxf3GiiN\" version=\"22.1.16\" type=\"device\"><diagram name=\"Page-1\" id=\"beBrEWIuwQJhH1_dIsJB\">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</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(24, 20, 29)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "svg.ge-export-svg-dark &gt; * { filter: invert(100%) hue-rotate(180deg); }&#xa;svg.ge-export-svg-dark image { filter: invert(100%) hue-rotate(180deg) }"))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 50,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 50,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 190,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 190,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "6")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 194,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "6")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 100,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 100,
      marginLeft: 351
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "5")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "5")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 140,
    rx: 20,
    ry: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 140,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 144,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 20,
    rx: 20,
    ry: 20,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 20,
      marginLeft: 291
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "4")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 24,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "4")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 79.9 65.97 L 76.25 68.94 L 73.58 70.84 L 70.62 72.66 L 67.31 74.49 L 63.7 76.31 L 59.93 78.12 L 56.34 79.78 L 52.83 81.38 L 49.22 83.08 L 45.72 84.89 L 42.43 86.79 L 39.49 88.84 L 36.79 91.13 L 34.39 93.6 L 32.31 96.12 L 30.64 98.53 L 29.64 100.7 L 29.04 102.8 L 28.67 104.83 L 28.47 106.67 L 28.31 109.53 L 28.35 111.79 L 28.44 113.69 L 28.54 116.14 L 28.58 118.71 L 28.49 119.26 L 28.23 119.75 L 27.83 120.13 L 27.32 120.36 L 26.77 120.42 L 26.23 120.3 L 25.75 120.02 L 25.4 119.6 L 25.19 119.08 L 25.16 118.52 L 25.31 117.99 L 25.62 117.53 L 26.06 117.2 L 26.59 117.02 L 27.14 117.02 L 27.67 117.2 L 28.11 117.53 L 28.42 117.99 L 28.56 118.52 L 28.54 119.08 L 28.33 119.6 L 27.97 120.02 L 27.5 120.3 L 26.96 120.42 L 26.4 120.36 L 25.9 120.13 L 25.49 119.75 L 25.24 119.26 L 25.15 118.71 L 25.15 118.71 L 25.18 116.14 L 25.3 113.68 L 25.4 111.74 L 25.59 109.27 L 26.04 106.29 L 26.42 104.34 L 26.98 102.12 L 27.84 99.8 L 29.13 97.44 L 30.96 94.99 L 33.15 92.39 L 35.67 89.8 L 38.49 87.43 L 41.56 85.28 L 44.93 83.35 L 48.47 81.51 L 52.11 79.78 L 55.6 78.18 L 59.16 76.51 L 62.89 74.7 L 66.42 72.89 L 69.63 71.09 L 72.47 69.26 L 75.04 67.48 L 78.65 64.45 L 78.85 64.32 L 79.07 64.25 L 79.31 64.22 L 79.54 64.26 L 79.76 64.35 L 79.95 64.49 L 80.1 64.67 L 80.21 64.89 L 80.26 65.12 L 80.25 65.36 L 80.18 65.58 L 80.07 65.79 L 79.9 65.97 L 79.9 65.97",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 108.67 57.99 L 110.15 58.59 L 112.11 59.46 L 114.64 60.88 L 116.16 61.98 L 117.73 63.2 L 119.44 64.66 L 121.15 66.27 L 122.95 68.09 L 124.75 70.11 L 126.64 72.45 L 128.56 74.84 L 130.41 77.21 L 132.15 79.69 L 133.68 82.1 L 135.17 84.57 L 136.56 87.13 L 137.84 89.72 L 138.95 92.12 L 139.82 94.41 L 140.59 96.72 L 141.29 98.94 L 141.99 101.16 L 142.69 103.39 L 143.39 105.51 L 144.13 107.7 L 144.82 109.84 L 145.58 112 L 146.4 114.14 L 147.25 116.24 L 148.03 118.24 L 148.78 120 L 149.53 121.7 L 150.67 124.4 L 150.73 124.73 L 150.68 125.07 L 150.53 125.37 L 150.29 125.62 L 149.98 125.77 L 149.65 125.81 L 149.31 125.74 L 149.01 125.57 L 148.79 125.32 L 148.66 125.01 L 148.63 124.67 L 148.72 124.33 L 148.9 124.05 L 149.17 123.84 L 149.49 123.72 L 149.83 123.72 L 150.16 123.82 L 150.43 124.02 L 150.63 124.3 L 150.72 124.63 L 150.71 124.97 L 150.59 125.28 L 150.38 125.54 L 150.09 125.73 L 149.76 125.81 L 149.42 125.77 L 149.11 125.64 L 148.86 125.41 L 148.69 125.12 L 148.69 125.12 L 147.7 122.47 L 146.99 120.71 L 146.3 118.9 L 145.57 116.91 L 144.72 114.79 L 143.89 112.59 L 143.1 110.37 L 142.46 108.26 L 141.73 106.05 L 141.06 103.89 L 140.39 101.65 L 139.73 99.41 L 139.1 97.2 L 138.39 94.92 L 137.64 92.71 L 136.57 90.36 L 135.3 87.82 L 133.93 85.33 L 132.43 82.91 L 130.9 80.58 L 129.17 78.2 L 127.28 75.9 L 125.3 73.59 L 123.36 71.41 L 121.53 69.57 L 119.69 67.91 L 117.98 66.45 L 116.27 65.12 L 114.73 63.98 L 113.34 63.01 L 111.04 61.62 L 109.28 60.66 L 107.81 60.01 L 107.59 59.88 L 107.4 59.69 L 107.25 59.47 L 107.17 59.22 L 107.15 58.96 L 107.19 58.7 L 107.29 58.45 L 107.45 58.24 L 107.65 58.08 L 107.89 57.96 L 108.15 57.91 L 108.42 57.92 L 108.67 57.99 L 108.67 57.99",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.28 136.49 L 41.2 136.5 L 43.81 136.43 L 45.27 136.4 L 46.82 136.44 L 48.38 136.5 L 50.19 136.64 L 52.11 136.82 L 54.1 137.01 L 56.23 137.22 L 58.56 137.45 L 61.09 137.69 L 63.68 137.88 L 66.51 138.05 L 69.39 138.14 L 72.6 138.2 L 76.09 138.23 L 80.15 138.26 L 84.7 138.27 L 89.52 138.28 L 94.49 138.34 L 99.43 138.42 L 104.25 138.5 L 108.79 138.64 L 112.96 138.79 L 116.41 138.96 L 119.48 139.18 L 122.18 139.42 L 124.66 139.59 L 126.81 139.72 L 128.72 139.83 L 130.49 139.95 L 132.17 140.07 L 133.85 140.2 L 136.29 140.32 L 138.61 140.42 L 140.02 140.53 L 142.67 140.69 L 145.44 140.85 L 148.39 141.09 L 148.81 141.18 L 149.16 141.4 L 149.43 141.72 L 149.59 142.12 L 149.61 142.54 L 149.5 142.95 L 149.26 143.29 L 148.92 143.55 L 148.52 143.68 L 148.09 143.68 L 147.69 143.54 L 147.36 143.29 L 147.12 142.94 L 147.01 142.53 L 147.03 142.11 L 147.2 141.72 L 147.47 141.39 L 147.84 141.18 L 148.25 141.09 L 148.67 141.14 L 149.05 141.31 L 149.35 141.61 L 149.55 141.98 L 149.62 142.4 L 149.55 142.81 L 149.35 143.19 L 149.04 143.48 L 148.66 143.65 L 148.24 143.7 L 148.24 143.7 L 145.25 143.43 L 143.81 143.31 L 141.13 143.09 L 138.44 142.79 L 136.09 142.53 L 133.63 142.2 L 131.99 141.98 L 130.3 141.76 L 128.56 141.52 L 126.68 141.29 L 124.54 141.04 L 122.05 140.81 L 119.38 140.56 L 116.35 140.35 L 112.9 140.18 L 108.76 140.03 L 104.23 139.9 L 99.4 139.82 L 94.48 139.76 L 89.52 139.72 L 84.7 139.73 L 80.15 139.74 L 76.09 139.75 L 72.59 139.77 L 69.36 139.79 L 66.46 139.8 L 63.59 139.77 L 60.96 139.71 L 58.41 139.61 L 56.06 139.49 L 53.9 139.36 L 51.91 139.23 L 50.01 139.1 L 48.25 138.98 L 46.74 138.9 L 45.27 138.84 L 43.81 138.82 L 41.2 138.75 L 39.28 138.75 L 39 138.72 L 38.76 138.62 L 38.52 138.47 L 38.34 138.26 L 38.22 138.02 L 38.15 137.76 L 38.15 137.48 L 38.22 137.22 L 38.34 136.98 L 38.52 136.78 L 38.76 136.62 L 39 136.52 L 39.28 136.49 L 39.28 136.49",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 324.38 32.24 L 325.44 34.12 L 326.98 36.35 L 327.83 37.59 L 328.73 38.83 L 329.67 40.17 L 330.66 41.57 L 331.74 43.11 L 332.9 44.85 L 334.18 46.66 L 335.51 48.48 L 336.84 50.18 L 338.28 52.02 L 339.73 53.85 L 341.11 55.69 L 342.35 57.36 L 343.49 58.84 L 344.5 60.22 L 345.49 61.59 L 346.47 62.95 L 347.36 64.3 L 348.24 65.66 L 349.17 66.91 L 350.21 68.29 L 351.26 69.68 L 352.26 71.01 L 353.2 72.27 L 354.1 73.5 L 355.68 75.53 L 356.91 77.27 L 357.87 78.69 L 358.71 80.16 L 359.92 82.28 L 360.07 82.72 L 360.07 83.18 L 359.93 83.63 L 359.65 84 L 359.27 84.27 L 358.82 84.4 L 358.35 84.38 L 357.92 84.21 L 357.56 83.91 L 357.32 83.51 L 357.21 83.06 L 357.26 82.6 L 357.45 82.17 L 357.77 81.83 L 358.17 81.61 L 358.63 81.53 L 359.1 81.6 L 359.51 81.81 L 359.83 82.14 L 360.03 82.57 L 360.09 83.03 L 360 83.48 L 359.76 83.89 L 359.41 84.19 L 358.97 84.37 L 358.51 84.4 L 358.06 84.28 L 357.67 84.02 L 357.38 83.66 L 357.38 83.66 L 355.87 80.8 L 355.12 79.44 L 354.21 77.94 L 352.93 76.07 L 352.12 74.93 L 351.25 73.69 L 350.35 72.43 L 349.37 71.09 L 348.34 69.7 L 347.27 68.28 L 346.29 66.89 L 345.45 65.53 L 344.64 64.21 L 343.71 62.82 L 342.78 61.43 L 341.86 60.05 L 340.76 58.53 L 339.55 56.87 L 338.2 55.09 L 336.71 53.29 L 335.2 51.5 L 333.79 49.77 L 332.39 47.98 L 330.99 46.16 L 329.81 44.51 L 328.68 42.96 L 327.68 41.55 L 326.77 40.22 L 325.86 38.91 L 325.05 37.66 L 324.25 36.42 L 323.54 35.21 L 322.44 33.35 L 322.34 33.1 L 322.3 32.84 L 322.32 32.57 L 322.4 32.31 L 322.55 32.08 L 322.74 31.9 L 322.98 31.76 L 323.24 31.69 L 323.51 31.68 L 323.77 31.73 L 324.01 31.85 L 324.22 32.02 L 324.38 32.24 L 324.38 32.24",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 200,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 215,
      marginLeft: 115
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "RES:1")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 219,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RES:1"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphdrawio2);
export default __webpack_public_path__ + "static/media/graph.drawio2.dd4a8b061ed01fc4e8e87a7b62fb393a.svg";
export { ForwardRef as ReactComponent };